import { Alert, Col, Row } from 'react-bootstrap'
import ExclamationIcon from '@assets/icons/iconmonstr-error-filled.svg'

import TeamCard, { TeamCardProps } from '../TeamCard/TeamCard'
import FramerMotion from '../../../../@shared/hooks/framerMotion'
import Icon from '../../../../@shared/components/icon/index'

export type TeamListProps = {
    list: TeamCardProps[]
    categoryClass: string
}

export default function TeamList({ list, categoryClass }: TeamListProps) {
    return (
        <Row>
            {list &&
                list.map((item: TeamCardProps, index: number) => (
                    <Col md={6} lg={3} className="my-3 my-md-4 my-lg-3" key={item.id ?? index}>
                        <FramerMotion>
                            <TeamCard item={{ categoryClass, ...item }}></TeamCard>
                        </FramerMotion>
                    </Col>
                ))}
            {!list ||
                (list.length === 0 && (
                    <Alert variant="dark">
                        <Icon customClass="alert-exclamation mb-2" source={ExclamationIcon.src}></Icon>
                        <span>The content could not be loaded</span>
                    </Alert>
                ))}
        </Row>
    )
}
